<style lang="stylus">
    .pageset-container
        width 100%
        background-color $right-view-backcolor
        font-size 12px
        .pageset-box
            // margin-bottom 10px
            .pageset-title
                right-view-subtitle()
        .options-grid
            flex 1
            padding 0px
            >div
                display flex
                align-items center
                justify-content space-between
                margin-bottom 16px
                >span
                    display block
                    width 140px
                    margin-right 32px
                >div
                    width: 160px
                input
                    margin-right 8px
                    cursor pointer
                label
                    cursor pointer
            .item-box
                display block
                label
                    display block
                    margin 18px 0
                span
                    margin-right 2px
        .pageset-btnbox
            color $right-view-content-textcolor
            height 66px
            display flex
            justify-content space-between
            .activeFunc
                background-color var(--themeActived)
            .btnbox-menu
                position relative
                width 62px
                height 56px
                border-radius 6px
                cursor pointer
                text-align center
                user-select none
                border-radius: 6px;
                >p
                    padding 0 2px
                    text-overflow ellipsis
                    overflow hidden
                    overflow hidden
                    white-space nowrap
                &.ban-btn
                    opacity .2
                    pointer-events none
                &:not(.ban-btn):hover
                    background-color var(--bg-color-pageset-hover)
                    .vip-icon
                        display block
                .btnbox-menu-imgbox
                    position relative
                    width 27px
                    height 27px
                    margin 3px auto
                    >.item-icon
                        width 24px
                        height 24px
                        pointer-events none
                        color var(--svg-color-gray-42)
                        fill var(--svg-color-gray-75)
                    .item-arrow
                        position absolute
                        top 2px
                        left 22px
                        width 6px
                        height 22px
                        margin-left 4px
                        cursor pointer
                .vip-icon
                    display none
                    position absolute
                    right 4px
                    top 4px
        .pageset-sizebox
            color $right-view-content-textcolor
            .pageset-line
                position relative
                .ivu-checkbox
                    margin-right 8px;
                &:not(:last-child)
                    margin-bottom 16px
            .pageset-selector
                display inline-block
                position absolute
                top 24px
                left 0
                right 0
                padding-left 22px
                .inputBox
                    display inline-block
                    width 100%
                    height 27px
                    line-height 19px
                    padding 4px 7px
                    font-size 12px
                    border 1px solid var(--border-color-ivu-input-number)
                    border-radius 4px
                    color var(--text-color-primary)
                    background-color var(--bg-color-white)
                    background-image none
                    position relative
                    cursor text
                    transition border .2s
                    p
                        white-space nowrap
                        overflow hidden
                        text-overflow ellipsis
                    &:not(.ban-select):hover
                        border-color var(--themeColor)
                .ivu-select-dropdown
                    max-width 222px
                    overflow auto
                    max-height 400px
                    margin 0
                    padding 0
                    .ivu-dropdown-item
                        padding unset
                        p
                            padding 7px 16px
                            color var(--text-color-primary)
                .ban-select
                    cursor not-allowed
                    background-color var(--bg-color-ivu-input-number-input-disabled)
                    color #ccc
                .ivu-dropdown-menu
                    border-radius 8px
                    padding 6px
                    .ivu-dropdown-item
                        border-radius 6px
                        &:hover
                            background var(--bg-color-ivu-dropdown-item-hover)

            .pageset-radioGroup
                >label
                    height 16px
                    line-height 16px
                    margin-bottom 48px
            .pageset-custombox
                position absolute
                top 88px
                left 0
                right 0
                padding-left 0px
                >span
                    display flex
                    align-items center
                    justify-content space-between
                    white-space nowrap
                    margin-bottom 16px
                .custombox-selector
                    width 80px
                    margin-left 10px
                .custombox-inputnumber
                    width 64px
                    margin-left 22px
                .sizebox-selector
                    margin-left 20px
                    width 80px
                    &.ivu-select-single
                        .ivu-select-selection
                            background-color var(--bg-color-primary)
            .sizebox-span
                display flex
                justify-content space-between
                align-items baseline
                padding-left 10px
                line-height 24px
                p
                    display inline-block
                    margin-top 12px
                    height 24px
                    color $right-view-content-textcolor
                .sizebox-selector
                    margin-left 20px
                    width 80px
                    margin-right 12px
        .pageset-pageNumbox
            // height 140px
            .pageNumbox-span
                display flex
                justify-content space-between
                align-items baseline
                padding-left 0px
                line-height 24px
                margin-bottom 12px
                p
                    display inline-block
                    margin-top 0px
                    color $right-view-content-textcolor
                .pageNumbox-selector
                    width 80px
                    &.ivu-select-single
                        .ivu-select-selection
                            background-color var(--bg-color-primary)
                    .ivu-select-item-focus
                        background transparent
                &:last-child
                    align-items  center
                    // margin-right 12px
        .pageset-timeDatebox
            // height 140px
            .timeDatebox-span
                display flex
                justify-content space-between
                align-items baseline
                padding-left 0px
                line-height 24px
                margin-bottom 12px
                p
                    display inline-block
                    margin-top 0px
                    color $right-view-content-textcolor
                .timeDatebox-selector
                    width 80px
                    &.ivu-select-single
                        .ivu-select-selection
                            background-color var(--bg-color-primary)
                    .ivu-select-item-selected
                        // background #f3f3f3 !important
                    .ivu-select-item-focus
                        background transparent
                &:last-child
                    align-items  center
                    // margin-right 12px
        .pageset-autoFitbox
            margin-bottom unset
            .autoFitbox-btn
                width 100%
                margin-left 0px
                margin-bottom 16px
                cursor pointer
                display flex
                align-items center
                padding: 4px 0;
                &:hover
                    background-color $right-view-content-hovercolor
                .autoFitbox-imgbox
                    height 22px
                    .item-icon
                        width 22px
                        height 22px
                .autoFitbox-text
                    margin-left 10px
                    flex 1
                    color $right-view-content-textcolor
            .page-grid-set
                margin-bottom 16px;
                .ivu-checkbox
                    margin-right 8px;
        .pageset-linebox
            height 160px
            .linebox-span
                padding-left 10px
                line-height 24px
                p
                    display inline-block
                    margin-top 12px
                    height 24px
                    color $right-view-content-textcolor
                .linebox-inputnumber
                    width 196px
                    margin-left 10px
                .linebox-selectbox
                    display inline-block
                    vertical-align middle
                    margin-left 10px
                    position relative
                    .showbox
                        width 196px
                        height 24px
                        border 1px solid #dcdee2
                        background-color #fff
                        border-radius 3px
                        transition border-color .2s ease-in-out
                        &:hover
                            border-color var(--themeHover)
                            cursor pointer
                        .item-icon
                            width 176px
                            height 18px
                            padding 0 10px
                            vertical-align middle
                    .linebox-selector
                        display block
                        position absolute
                        left 0
                        top 30px
                        list-style none
                        background-color #fff
                        box-shadow 0 1px 6px rgba(0,0,0,.2)
                        z-index 1
                        max-height 200px
                        overflow-y auto
                        li
                            padding 5px 10px
                            height 28px
                            transition background .2s linear
                            cursor pointer
                            &:hover
                                background-color #f3f3f3
                            .item-icon
                                width 100%
                                height 18px
                                max-height 400px
    .pageset-selector-dropdown
        max-height 400px
        margin 0
        padding 0
        .ivu-dropdown-item
            padding unset
            p
                padding 7px 16px
                color var(--text-color-primary)
</style>

<template>
    <setbox :setTitle="$t('title')">
        <div class="pageset-container">
            <div class="pageset-box pageset-btnbox">
                <div
                    :title="$t('content.pageBtn.bgColor')"
                    class="btnbox-menu"
                    @click="showColorBox($event)"
                    :class="{ activeFunc: activeFunc == 'rightPageBgColor' }"
                >
                    <div class="btnbox-menu-imgbox">
                        <iconSymbol class="item-icon" name="pageSetBgColor"></iconSymbol>
                    </div>
                    <p>{{ $t("content.pageBtn.bgColor") }}</p>
                </div>
                <div
                    :title="$t('content.pageBtn.delBg')"
                    class="btnbox-menu"
                    @click="setData('topbtn', 0)"
                    :class="{ activeFunc: activeFunc == 'rightPageDeleteBg', 'ban-btn': !isPageBg }"
                >
                    <div class="btnbox-menu-imgbox">
                        <iconSymbol class="item-icon" name="pageSetDelColor"></iconSymbol>
                    </div>
                    <p>{{ $t("content.pageBtn.delBg") }}</p>
                    <!-- <VipIcon v-if="!vip" /> -->
                </div>
                <div
                    :title="$t('content.pageBtn.waterMark')"
                    class="btnbox-menu"
                    @click="setData('topbtn', 1)"
                    :class="{ activeFunc: activeFunc == 'rightPageWaterMark' }"
                >
                    <div class="btnbox-menu-imgbox">
                        <iconSymbol class="item-icon" name="pageSetWaterMark"></iconSymbol>
                    </div>
                    <p>{{ $t("content.pageBtn.waterMark") }}</p>
                </div>
            </div>

            <div class="pageset-box pageset-sizebox">
                <p class="pageset-title" @click="toggleExpand('pageSetting')">{{ $t("content.pageSize.title") }}</p>
                <collapseTransition>
                    <div v-show="expandList.includes('pageSetting')">
                        <div class="pageset-line">
                            <Checkbox v-model="autoSize" @on-change="setData('expand')">{{ $t("content.pageSize.checkbox") }}</Checkbox>
                        </div>
                        <div class="pageset-line" style="height: 208px">
                            <RadioGroup class="pageset-radioGroup" v-model="sizeType" vertical @on-change="setData('setPageType')">
                                <Radio label="preset">{{ $t("content.pageSize.presetRadio") }}</Radio>
                                <Radio label="custom">{{ $t("content.pageSize.customRadio") }}</Radio>
                            </RadioGroup>
                            <div ref="pageDropdownBox">
                                <Dropdown
                                    trigger="custom"
                                    class="pageset-selector"
                                    :visible="visible"
                                    :transfer="true"
                                    :transfer-class-name="'pageset-selector-dropdown'"
                                    placement="bottom-end"
                                >
                                    <div
                                        class="inputBox"
                                        @click="handleOpen"
                                        :title="$t(getPageName())"
                                        :class="{ 'ban-select': sizeType == 'custom' }"
                                    >
                                        <p>{{ $t(getPageName()) }}</p>
                                    </div>
                                    <DropdownMenu slot="list">
                                        <DropdownItem v-for="item in pageSizeList" :name="item.id" :label="$t(item.text)" :key="item.id">
                                            <p @click="handleClose(item.id)">{{ $t(item.text) }}</p>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </div>

                            <div class="pageset-custombox">
                                <!-- <span>
                                    {{$t('content.pageSize.unit')}}:
                                    <i-select class="custombox-selector" size="small" :disabled="sizeType == 'preset'" v-model="pageUnit" @on-change="setData('pageUnit')">
                                        <i-option v-for="item in pageUnitList" :value="item.id" :label="$t(item.text)" :key="item.id">{{ $t(item.text) }}</i-option>
                                    </i-select>
                                </span> -->
                                <span>
                                    <!-- {{$t('content.pageSize.size')}}: -->
                                    <InputNumber
                                        :disabled="sizeType == 'preset'"
                                        class="custombox-inputnumber"
                                        size="small"
                                        style="width: 80px"
                                        :min="0"
                                        :max="maxPageWH"
                                        :parser="(value) => value.replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')"
                                        v-model="pageWidth"
                                        @on-focus="editLocker('focus', 'inputLocker')"
                                        @on-blur="
                                            editLocker('blur', 'inputLocker', () => {
                                                setData('diyWidth');
                                            })
                                        "
                                        @on-change="
                                            editLocker('edit', 'inputLocker', () => {
                                                setData('diyWidth');
                                            })
                                        "
                                        :active-change="false"
                                        @keyup.enter.native="iviewInputBlur($event)"
                                    />
                                    <InputNumber
                                        :disabled="sizeType == 'preset'"
                                        class="custombox-inputnumber"
                                        size="small"
                                        style="width: 80px"
                                        :min="0"
                                        :max="maxPageWH"
                                        :parser="(value) => value.replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')"
                                        v-model="pageHeight"
                                        @on-focus="editLocker('focus', 'inputLocker')"
                                        @on-blur="
                                            editLocker('blur', 'inputLocker', () => {
                                                setData('diyHeight');
                                            })
                                        "
                                        @on-change="
                                            editLocker('edit', 'inputLocker', () => {
                                                setData('diyHeight');
                                            })
                                        "
                                        :active-change="false"
                                        @keyup.enter.native="iviewInputBlur($event)"
                                    />
                                </span>
                                <span class="">
                                    <p>{{ $t("content.pageDirect.title") }}</p>
                                    <i-select
                                        :title="$t(`content.pageDirect.${isPortrait}`)"
                                        class="sizebox-selector"
                                        size="small"
                                        placement="bottom-end"
                                        v-model="isPortrait"
                                        @on-change="setData('direct')"
                                    >
                                        <i-option
                                            :title="$t('content.pageDirect.horizontal')"
                                            :value="'horizontal'"
                                            :label="$t('content.pageDirect.horizontal')"
                                        >
                                            {{ $t("content.pageDirect.horizontal") }}
                                        </i-option>
                                        <i-option
                                            :title="$t('content.pageDirect.vertical')"
                                            :value="'vertical'"
                                            :label="$t('content.pageDirect.vertical')"
                                        >
                                            {{ $t("content.pageDirect.vertical") }}
                                        </i-option>
                                    </i-select>
                                </span>
                                <span class="">
                                    <p>{{ $t("content.UnitForPage.title") }}</p>
                                    <i-select
                                        :title="$t(pageUnitList[pageUnit].text)"
                                        class="sizebox-selector"
                                        size="small"
                                        placement="bottom-end"
                                        v-model="pageUnit"
                                        @on-change="setData('pageUnit')"
                                    >
                                        <i-option
                                            :title="$t(item.text)"
                                            v-for="item in pageUnitList"
                                            :value="item.id"
                                            :label="$t(item.text)"
                                            :key="item.id"
                                        >
                                            {{ $t(item.text) }}
                                        </i-option>
                                    </i-select>
                                </span>
                            </div>
                        </div>
                    </div>
                </collapseTransition>
            </div>

            <div class="pageset-box pageset-pageNumbox">
                <p class="pageset-title" @click="toggleExpand('numSetting')">{{ $t("content.pageNum.title") }}</p>
                <collapseTransition>
                    <div v-show="expandList.includes('numSetting')">
                        <span class="pageNumbox-span">
                            <p>{{ $t("content.pageNum.pageNumStyle") }}</p>
                            <i-select
                                :title="$t(pageNumStyleList[pageNumStyle].text)"
                                class="pageNumbox-selector"
                                size="small"
                                v-model="pageNumStyle"
                                @on-change="setData('pageNumStyle')"
                            >
                                <i-option
                                    :title="$t(item.text)"
                                    v-for="item in pageNumStyleList"
                                    :value="item.id"
                                    :label="$t(item.text)"
                                    :key="item.id"
                                >
                                    {{ $t(item.text) }}
                                </i-option>
                            </i-select>
                        </span>
                        <span class="pageNumbox-span">
                            <p>{{ $t("content.pageNum.pageNumPosition") }}</p>
                            <i-select
                                :title="pageNumPositionTitle"
                                class="pageNumbox-selector"
                                size="small"
                                v-model="pageNumPosition"
                                :disabled="pageNumStyle == 0"
                                @on-change="setData('pageNumPosition')"
                            >
                                <i-option
                                    :title="$t(item.text)"
                                    v-for="item in pageNumPositionList"
                                    :value="item.id"
                                    :label="$t(item.text)"
                                    :key="item.id"
                                >
                                    {{ $t(item.text) }}
                                </i-option>
                            </i-select>
                        </span>
                    </div>
                </collapseTransition>
            </div>
            <div class="pageset-box pageset-timeDatebox">
                <p class="pageset-title" @click="toggleExpand('timeDateSeting')">{{ $t("content.timeDate.title") }}</p>
                <collapseTransition>
                    <div v-show="expandList.includes('timeDateSeting')">
                        <span class="timeDatebox-span">
                            <p>{{ $t("content.timeDate.timeDateType") }}</p>
                            <i-select
                                :title="$t(timeDateTypeList[timeDateType].text)"
                                class="timeDatebox-selector"
                                placement="bottom-end"
                                size="small"
                                v-model="timeDateType"
                                @on-change="setData('timeDateType')"
                            >
                                <i-option
                                    :title="$t(item.text)"
                                    v-for="item in timeDateTypeList"
                                    :value="item.id"
                                    :label="$t(item.text)"
                                    :key="item.id"
                                >
                                    {{ $t(item.text) }}
                                </i-option>
                            </i-select>
                        </span>
                        <span class="timeDatebox-span">
                            <p>{{ $t("content.timeDate.timeDateStyle") }}</p>
                            <i-select
                                :title="timeDateStyle"
                                class="timeDatebox-selector"
                                placement="bottom-end"
                                size="small"
                                v-model="timeDateStyle"
                                :disabled="timeDateType == 0"
                                @on-change="setData('timeDateStyle')"
                            >
                                <i-option
                                    :title="item.label"
                                    v-for="(item, index) in timeDateStyleList"
                                    :value="item.value"
                                    :label="item.label"
                                    :key="index"
                                >
                                    {{ item.label }}
                                </i-option>
                            </i-select>
                        </span>
                        <span class="timeDatebox-span">
                            <p>{{ $t("content.timeDate.timeDatePosition") }}</p>
                            <i-select
                                :title="$t(timeDatePositionList[timeDatePosition].text)"
                                class="timeDatebox-selector"
                                placement="bottom-end"
                                size="small"
                                v-model="timeDatePosition"
                                :disabled="timeDateType == 0"
                                @on-change="setData('timeDatePosition')"
                            >
                                <i-option
                                    :title="$t(item.text)"
                                    v-for="item in timeDatePositionList"
                                    :value="item.id"
                                    :label="$t(item.text)"
                                    :key="item.id"
                                >
                                    {{ $t(item.text) }}
                                </i-option>
                            </i-select>
                        </span>
                    </div>
                </collapseTransition>
            </div>
            <div class="pageset-box pageset-autoFitbox">
                <p class="pageset-title" @click="toggleExpand('pageFit')">{{ $t("content.autoFit.title") }}</p>
                <collapseTransition>
                    <div class="autoFitbox-btn" @click="setData('autoFit')" v-show="expandList.includes('pageFit')">
                        <div class="autoFitbox-imgbox">
                            <iconSymbol class="item-icon" :name="pageSetAuotFitIcon"></iconSymbol>
                        </div>
                        <p class="autoFitbox-text">{{ $t("content.autoFit.autoFitText") }}</p>
                    </div>
                </collapseTransition>
            </div>
            <div class="pageset-box pageset-autoFitbox">
                <p class="pageset-title" @click="toggleExpand('gridSetting')">{{ $t("content.grid.title") }}</p>
                <collapseTransition>
                    <div v-show="expandList.includes('gridSetting')">
                        <div class="page-grid-set">
                            <Checkbox v-model="gridFitRuler">{{ $t("content.grid.fitRuler") }}</Checkbox>
                        </div>
                        <div class="options-grid">
                            <div>
                                <span>{{ $t("content.grid.value1") }}</span>
                                <InputNumber
                                    style="width: 80px"
                                    :disabled="isFitRuler"
                                    v-model="gridHSp"
                                    size="small"
                                    :min="1"
                                    :max="1000"
                                    :step="1"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('gridHSp');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('gridHSp');
                                        })
                                    "
                                    :active-change="false"
                                />
                            </div>
                            <div>
                                <span>{{ $t("content.grid.value2") }}</span>
                                <InputNumber
                                    style="width: 80px"
                                    :disabled="isFitRuler"
                                    v-model="gridHSub"
                                    size="small"
                                    :min="1"
                                    :max="1000"
                                    :step="1"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('gridHSub');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('gridHSub');
                                        })
                                    "
                                    :active-change="false"
                                />
                            </div>
                            <div>
                                <span>{{ $t("content.grid.value3") }}</span>
                                <InputNumber
                                    style="width: 80px"
                                    :disabled="isFitRuler"
                                    v-model="gridVSp"
                                    size="small"
                                    :min="1"
                                    :max="1000"
                                    :step="1"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('gridVSp');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('gridVSp');
                                        })
                                    "
                                />
                            </div>
                            <div>
                                <span>{{ $t("content.grid.value4") }}</span>
                                <InputNumber
                                    style="width: 80px"
                                    :disabled="isFitRuler"
                                    v-model="gridVSub"
                                    size="small"
                                    :min="1"
                                    :max="1000"
                                    :step="1"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('gridVSub');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('gridVSub');
                                        })
                                    "
                                />
                            </div>
                        </div>
                    </div>
                </collapseTransition>
            </div>
        </div>
    </setbox>
</template>

<script lang="ts">
    declare var UnitUtil: any;
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import setbox from "./BaseSet.vue";
    import collapseTransition from "@/public/utils/collapse-transition.js";

    @Component({
        components: {
            setbox,
            collapseTransition,
        },
    })
    export default class PageSet extends Vue {
        @Inject()
        ["iviewInputBlur"];

        get pageSetAuotFitIcon() {
            let iconStr = "pageSetAutoFit";
            if (window["EDCONFIG"].IS_SDK) {
                iconStr += `-sdk`;
                if (this.isDarkTheme()) {
                    iconStr += "-dark";
                }
            }
            return iconStr;
        }
        // page size
        pageSize: string = "";
        pageSizeList: Array<object> = [
            {
                id: 61,
                text: "content.pageSize.pageSizeList[61]",
            },
            {
                id: 62,
                text: "content.pageSize.pageSizeList[62]",
            },
            {
                id: 0,
                text: "content.pageSize.pageSizeList[0]",
            },
            {
                id: 1,
                text: "content.pageSize.pageSizeList[1]",
            },
            {
                id: 2,
                text: "content.pageSize.pageSizeList[2]",
            },
            {
                id: 3,
                text: "content.pageSize.pageSizeList[3]",
            },
            {
                id: 4,
                text: "content.pageSize.pageSizeList[4]",
            },
            {
                id: 5,
                text: "content.pageSize.pageSizeList[5]",
            },
            {
                id: 6,
                text: "content.pageSize.pageSizeList[6]",
            },
            {
                id: 7,
                text: "content.pageSize.pageSizeList[7]",
            },
            {
                id: 8,
                text: "content.pageSize.pageSizeList[8]",
            },
            {
                id: 9,
                text: "content.pageSize.pageSizeList[9]",
            },
            {
                id: 10,
                text: "content.pageSize.pageSizeList[10]",
            },
            {
                id: 11,
                text: "content.pageSize.pageSizeList[11]",
            },
            {
                id: 12,
                text: "content.pageSize.pageSizeList[12]",
            },
            {
                id: 13,
                text: "content.pageSize.pageSizeList[13]",
            },
            {
                id: 14,
                text: "content.pageSize.pageSizeList[14]",
            },
            {
                id: 15,
                text: "content.pageSize.pageSizeList[15]",
            },
            {
                id: 16,
                text: "content.pageSize.pageSizeList[16]",
            },
            {
                id: 17,
                text: "content.pageSize.pageSizeList[17]",
            },
            {
                id: 18,
                text: "content.pageSize.pageSizeList[18]",
            },
            {
                id: 19,
                text: "content.pageSize.pageSizeList[19]",
            },
            {
                id: 20,
                text: "content.pageSize.pageSizeList[20]",
            },
            {
                id: 21,
                text: "content.pageSize.pageSizeList[21]",
            },
            {
                id: 22,
                text: "content.pageSize.pageSizeList[22]",
            },
            {
                id: 23,
                text: "content.pageSize.pageSizeList[23]",
            },
            {
                id: 24,
                text: "content.pageSize.pageSizeList[24]",
            },
            {
                id: 25,
                text: "content.pageSize.pageSizeList[25]",
            },
            {
                id: 26,
                text: "content.pageSize.pageSizeList[26]",
            },
            {
                id: 27,
                text: "content.pageSize.pageSizeList[27]",
            },
            {
                id: 28,
                text: "content.pageSize.pageSizeList[28]",
            },
            {
                id: 29,
                text: "content.pageSize.pageSizeList[29]",
            },
            {
                id: 30,
                text: "content.pageSize.pageSizeList[30]",
            },
            {
                id: 31,
                text: "content.pageSize.pageSizeList[31]",
            },
            {
                id: 32,
                text: "content.pageSize.pageSizeList[32]",
            },
            {
                id: 33,
                text: "content.pageSize.pageSizeList[33]",
            },
            {
                id: 34,
                text: "content.pageSize.pageSizeList[34]",
            },
            {
                id: 35,
                text: "content.pageSize.pageSizeList[35]",
            },
            {
                id: 36,
                text: "content.pageSize.pageSizeList[36]",
            },
            {
                id: 37,
                text: "content.pageSize.pageSizeList[37]",
            },
            {
                id: 38,
                text: "content.pageSize.pageSizeList[38]",
            },
            {
                id: 39,
                text: "content.pageSize.pageSizeList[39]",
            },
            {
                id: 40,
                text: "content.pageSize.pageSizeList[40]",
            },
            {
                id: 41,
                text: "content.pageSize.pageSizeList[41]",
            },
            {
                id: 42,
                text: "content.pageSize.pageSizeList[42]",
            },
            {
                id: 43,
                text: "content.pageSize.pageSizeList[43]",
            },
            {
                id: 44,
                text: "content.pageSize.pageSizeList[44]",
            },
            {
                id: 45,
                text: "content.pageSize.pageSizeList[45]",
            },
            {
                id: 46,
                text: "content.pageSize.pageSizeList[46]",
            },
            {
                id: 47,
                text: "content.pageSize.pageSizeList[47]",
            },
            {
                id: 48,
                text: "content.pageSize.pageSizeList[48]",
            },
            {
                id: 49,
                text: "content.pageSize.pageSizeList[49]",
            },
            {
                id: 50,
                text: "content.pageSize.pageSizeList[50]",
            },
            {
                id: 51,
                text: "content.pageSize.pageSizeList[51]",
            },
            {
                id: 52,
                text: "content.pageSize.pageSizeList[52]",
            },
            {
                id: 53,
                text: "content.pageSize.pageSizeList[53]",
            },
            {
                id: 54,
                text: "content.pageSize.pageSizeList[54]",
            },
            {
                id: 55,
                text: "content.pageSize.pageSizeList[55]",
            },
            {
                id: 56,
                text: "content.pageSize.pageSizeList[56]",
            },
            {
                id: 57,
                text: "content.pageSize.pageSizeList[57]",
            },
            {
                id: 58,
                text: "content.pageSize.pageSizeList[58]",
            },
            {
                id: 59,
                text: "content.pageSize.pageSizeList[59]",
            },
            {
                id: 60,
                text: "content.pageSize.pageSizeList[60]",
            },
        ];
        pageUnitList: Array<object> = [
            {
                id: 0,
                text: "content.pageSize.pageUnitList[0]",
            },
            {
                id: 1,
                text: "content.pageSize.pageUnitList[1]",
            },
            {
                id: 2,
                text: "content.pageSize.pageUnitList[2]",
            },
            {
                id: 3,
                text: "content.pageSize.pageUnitList[3]",
            },
            {
                id: 4,
                text: "content.pageSize.pageUnitList[4]",
            },
            {
                id: 5,
                text: "content.pageSize.pageUnitList[5]",
            },
            {
                id: 6,
                text: "content.pageSize.pageUnitList[6]",
            },
            {
                id: 7,
                text: "content.pageSize.pageUnitList[7]",
            },
            {
                id: 8,
                text: "content.pageSize.pageUnitList[8]",
            },
            {
                id: 9,
                text: "content.pageSize.pageUnitList[9]",
            },
            {
                id: 10,
                text: "content.pageSize.pageUnitList[10]",
            },
            {
                id: 11,
                text: "content.pageSize.pageUnitList[11]",
            },
            {
                id: 12,
                text: "content.pageSize.pageUnitList[12]",
            },
            {
                id: 13,
                text: "content.pageSize.pageUnitList[13]",
            },
        ];
        widthNum: number = 0;
        heightNum: number = 0;
        // page num
        pageNumStyleList: Array<object> = [
            {
                id: 0,
                text: "content.pageNum.pageNumStyleList[0]",
            },
            {
                id: 1,
                text: "content.pageNum.pageNumStyleList[1]",
            },
            {
                id: 2,
                text: "content.pageNum.pageNumStyleList[2]",
            },
            {
                id: 3,
                text: "content.pageNum.pageNumStyleList[3]",
            },
            {
                id: 4,
                text: "content.pageNum.pageNumStyleList[4]",
            },
        ];
        pageNumPositionList: Array<{ id: number; text: string }> = [
            {
                id: 0,
                text: "content.pageNum.pageNumPositionList[0]",
            },
            {
                id: 1,
                text: "content.pageNum.pageNumPositionList[1]",
            },
            {
                id: 2,
                text: "content.pageNum.pageNumPositionList[2]",
            },
        ];
        //tiemDate
        timeDateTypeList: Array<object> = [
            {
                id: 0,
                text: "content.timeDate.timeDateTypeList[0]",
            },
            {
                id: 1,
                text: "content.timeDate.timeDateTypeList[1]",
            },
            {
                id: 2,
                text: "content.timeDate.timeDateTypeList[2]",
            },
            {
                id: 3,
                text: "content.timeDate.timeDateTypeList[3]",
            },
        ];
        timeDateStyleList = [];

        timeDatePositionList: Array<object> = [
            {
                id: 0,
                text: "content.timeDate.timeDatePositionList[0]",
            },
            {
                id: 1,
                text: "content.timeDate.timeDatePositionList[1]",
            },
            {
                id: 2,
                text: "content.timeDate.timeDatePositionList[2]",
            },
            {
                id: 3,
                text: "content.timeDate.timeDatePositionList[3]",
            },
            {
                id: 4,
                text: "content.timeDate.timeDatePositionList[4]",
            },
            {
                id: 5,
                text: "content.timeDate.timeDatePositionList[5]",
            },
        ];

        // line
        lineWidth: number = 0;
        lineStyle: number = 0;
        lineArrowL: number = 0;
        lineArrowR: number = 0;
        showStyleSelector: boolean = false;
        showArrowLSelector: boolean = false;
        showArrowRSelector: boolean = false;

        inputLocker: boolean = false;
        visible: boolean = false;
        expandList: Array<string> = [];
        maxPageWH = this.pageUnit == 3 ? 0.0026 : parseFloat(UnitUtil.pixelToUnit(10000, this.pageUnit + 9).toFixed(2));

        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }

        setPageCustomSize() {
            let view = window["_view"];
            view.clearLastUserSetPredefinedPaper(this.pageWidth, this.pageHeight, this.pageUnit);
            view.setPageSize(this.pageWidth, this.pageHeight);
        }
        setData(type, index) {
            let view = window["_view"];
            let map = new Map([
                [
                    "topbtn",
                    () => {
                        if (!!index) {
                            this.showWaterMark();
                        } else {
                            // if (!this.vip) {
                            //     this.$checkAuth({ type: "pageBackgroundColor", buyTrigger: "setBackgroundPop" });
                            // } else {
                            this.delBg();
                            // }
                        }
                    },
                ], // 顶部按钮
                [
                    "expand",
                    () => {
                        view.setAutoSize(this.autoSize);
                    },
                ], // 自动拓展页面大小
                [
                    "setPageType",
                    () => {
                        if (this.sizeType == "custom") {
                            this.setPageCustomSize();
                        } else {
                            view.setPredefinedPaper(this.preDefinedPaper);
                        }
                    },
                ], // 设置页面类型
                [
                    "autoSize",
                    () => {
                        view.setPredefinedPaper(this.preDefinedPaper);
                        this.$track("rightPanel", "page setting", "auto page size");
                    },
                ], // 预设页面大小
                [
                    "diyWidth",
                    () => {
                        this.setPageCustomSize();
                    },
                ], // 自定义宽度
                [
                    "diyHeight",
                    () => {
                        this.setPageCustomSize();
                    },
                ], // 自定义高度
                [
                    "direct",
                    () => {
                        view.setPortrait(this.isPortrait === "vertical");
                    },
                ], // 页面方向
                [
                    "pageUnit",
                    () => {
                        view.setPageUnit(this.pageUnit); // 页面单位
                        this.maxPageWH = this.pageUnit == 3 ? 0.0026 : parseFloat(UnitUtil.pixelToUnit(10000, this.pageUnit + 9).toFixed(2));
                    },
                ],
                [
                    "pageNumStyle",
                    () => {
                        view.setPageNumberStyle(this.pageNumStyle);
                    },
                ], // 页码样式
                [
                    "pageNumPosition",
                    () => {
                        view.setPageNumberPos(this.pageNumPosition + 1);
                    },
                ], // 页码位置
                [
                    "timeDateType",
                    () => {
                        view.setTimeDateType(this.timeDateType);
                    },
                ], //时间日期类型
                [
                    "timeDateStyle",
                    () => {
                        view.setTimeDateStyle(this.timeDateStyle);
                    },
                ], //时间日期样式
                [
                    "timeDatePosition",
                    () => {
                        view.setTimeDatePos(this.timeDatePosition);
                    },
                ], //时间日期位置
                [
                    "autoFit",
                    () => {
                        view.fittoDrawing();
                        this.$track("rightPanel", "page setting", "fit to draw");
                    },
                ], // 页面适应到绘图
                [
                    "gridHSp",
                    () => {
                        view._doc._config._gridHSp = this.gridHSp;
                        view.modifyGrid();
                    },
                ],
                [
                    "gridHSub",
                    () => {
                        view._doc._config._gridHSub = this.gridHSub;
                        view.modifyGrid();
                    },
                ],
                [
                    "gridVSp",
                    () => {
                        view._doc._config._gridVSp = this.gridVSp;
                        view.modifyGrid();
                    },
                ],
                [
                    "gridVSub",
                    () => {
                        view._doc._config._gridVSub = this.gridVSub;
                        view.modifyGrid();
                    },
                ],
            ]);
            map.get(type)();
        }
        getPageName() {
            const currentItem: any = this.pageSizeList.find((item: any) => item.id === this.preDefinedPaper);
            if (currentItem) {
                return currentItem.text;
            } else {
                return "";
            }
        }
        handleOpen() {
            if (this.sizeType == "custom") return;
            this.visible = true;
            window.addEventListener("click", this.closeDropdown);
        }
        handleClose(index) {
            this.visible = false;
            this.preDefinedPaper = index;
            window["_view"].setPredefinedPaper(this.preDefinedPaper);
            window.removeEventListener("click", this.closeDropdown);
        }
        closeDropdown(e) {
            let objTarget = this.$refs.pageDropdownBox as HTMLElement;
            if (objTarget != e.target && !objTarget.contains(e.target)) {
                this.visible = false;
                window.removeEventListener("click", this.closeDropdown);
            }
        }

        delBg() {
            // 删除背景
            this.$track("rightPanel", "page setting", "delete bg");
            this.activeFunc = "";
            window["_view"].removePageBkgnd();
            this.$store.commit("setPageStat", {
                type: "pageBackgroundColor",
                data: "#ffffff",
            });
        }
        showWaterMark() {
            // 显示水印弹窗
            this.$track("rightPanel", "page setting", "watermark");
            this.activeFunc = "";
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "InsertWaterMark",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        showColorBox(e) {
            // 显示颜色弹窗
            this.activeFunc = "";
            let node = e.target;
            let payload = {
                type: this.fmtType.background,
                index: 10,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "background" });
            });
        }
        toggleExpand(name) {
            if (this.expandList.includes(name)) {
                for (let i = 0; i < this.expandList.length; i++) {
                    if (this.expandList[i] == name) {
                        this.expandList.splice(i, 1);
                        break;
                    }
                }
            } else {
                this.expandList.push(name);
            }
            this.$store.commit("setPageStat", { type: "expandList", data: this.expandList });
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get color() {
            return this.$store.state.ui.onceColor;
        }
        get autoSize() {
            return this.$store.state.page.autoSize;
        }
        get sizeType() {
            return this.$store.state.page.sizeType == 0 ? "preset" : "custom";
        }
        get preDefinedPaper() {
            return this.$store.state.page.preDefinedPaper;
        }
        get pageUnit() {
            return this.$store.state.page.pageUnit;
        }
        get pageWidth() {
            return Math.round(parseFloat(this.$store.state.page.pageWidth) * 1000000) / 1000000;
        }
        get pageHeight() {
            return Math.round(parseFloat(this.$store.state.page.pageHeight) * 1000000) / 1000000;
        }
        get isPortrait() {
            return !this.$store.state.page.isPortrait ? "horizontal" : "vertical";
        }
        get pageNumStyle() {
            return this.$store.state.page.pageNumStyle;
        }
        get pageNumPosition() {
            return this.$store.state.page.pageNumPosition - 1;
        }

        get pageNumPositionTitle() {
            let temp = this.pageNumPositionList[this.pageNumPosition]?.text;
            return temp ? this.$t(temp) : "";
        }

        get timeDateType() {
            return this.$store.state.page.timeDateType;
        }
        get timeDateStyle() {
            return this.$store.state.page.timeDateStyle;
        }
        get timeDatePosition() {
            return this.$store.state.page.timeDatePosition;
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        get isPageBg() {
            return this.$store.state.page.isPageBg;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }
        set autoSize(v) {
            this.$store.commit("setPageStat", {
                type: "autoSize",
                data: v,
            });
        }
        set sizeType(v) {
            this.$store.commit("setPageStat", {
                type: "sizeType",
                data: v == "preset" ? 0 : 1,
            });
        }
        set preDefinedPaper(v) {
            this.$store.commit("setPageStat", {
                type: "preDefinedPaper",
                data: v,
            });
        }
        set pageUnit(v) {
            this.$store.commit("setPageStat", {
                type: "pageUnit",
                data: v,
            });
            this.maxPageWH = parseFloat(UnitUtil.pixelToUnit(10000, this.pageUnit + 9).toFixed(2));
        }
        set pageWidth(v: any) {
            this.$store.commit("setPageStat", {
                type: "pageWidth",
                data: v == null ? 0 : v,
            });
        }
        set pageHeight(v: any) {
            this.$store.commit("setPageStat", {
                type: "pageHeight",
                data: v == null ? 0 : v,
            });
        }
        set isPortrait(v) {
            this.$store.commit("setPageStat", {
                type: "isPortrait",
                data: v == "vertical" ? true : false,
            });
        }
        set pageNumStyle(v) {
            this.$store.commit("setPageStat", {
                type: "pageNumStyle",
                data: v,
            });
        }
        set pageNumPosition(v) {
            this.$store.commit("setPageStat", {
                type: "pageNumPosition",
                data: v + 1,
            });
        }
        set timeDateType(v) {
            this.$store.commit("setPageStat", {
                type: "timeDateType",
                data: v,
            });
        }
        set timeDateStyle(v) {
            this.$store.commit("setPageStat", {
                type: "timeDateStyle",
                data: v,
            });
        }
        set timeDatePosition(v) {
            this.$store.commit("setPageStat", {
                type: "timeDatePosition",
                data: v,
            });
        }
        // Grid Setting
        get gridFitRuler() {
            return this.$store.state.page.gridFitRuler;
        }
        set gridFitRuler(v) {
            let view = window["_view"];
            view._doc._config._fitRuler = v;
            this.$store.commit("setPageStat", {
                type: "gridFitRuler",
                data: view._doc._config._fitRuler,
            });
            view.modifyGrid();
        }
        get isFitRuler() {
            return this.$store.state.page.gridFitRuler;
        }
        get gridHSp() {
            return this.$store.state.page.gridHSp;
        }
        set gridHSp(v) {
            this.$store.commit("setPageStat", {
                type: "gridHSp",
                data: v || 1,
            });
        }
        get gridHSub() {
            return this.$store.state.page.gridHSub;
        }
        set gridHSub(v) {
            this.$store.commit("setPageStat", {
                type: "gridHSub",
                data: v || 1,
            });
        }
        get gridVSp() {
            return this.$store.state.page.gridVSp;
        }
        set gridVSp(v) {
            this.$store.commit("setPageStat", {
                type: "gridVSp",
                data: v || 1,
            });
        }
        get gridVSub() {
            return this.$store.state.page.gridVSub;
        }
        set gridVSub(v) {
            this.$store.commit("setPageStat", {
                type: "gridVSub",
                data: v || 1,
            });
        }

        beforeDestroy() {
            this.visible = false;
            window.removeEventListener("click", this.closeDropdown);
        }
        mounted() {
            this.expandList = [...this.$store.state.page.expandList];
            var mouthEN = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var weekEN = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
            var date = new Date();
            var yyyy = date.getFullYear();
            var M = date.getMonth() + 1;
            var d = date.getDate();
            var weekd = date.getDay();
            var h = date.getHours();
            var m = date.getMinutes();
            var yy = yyyy.toString().substring(2);
            var MM = M < 10 ? "0" + M : M;
            var dd = d < 10 ? "0" + d : d;
            //var hh = h < 10 ? '0' + h : h;
            var HH = h < 10 ? "0" + h : h;
            var mm = m < 10 ? "0" + m : m;
            var MMMM = mouthEN[M - 1];
            var dddd = weekEN[weekd - 1];
            var MMM = mouthEN[M - 1];
            this.timeDateStyleList = [
                { label: `${yyyy}-${MM}-${dd}`, value: "yyyy-MM-dd" },
                { label: `${dd}/${MM}/${yyyy}`, value: "dd/MM/yyyy" },
                { label: `${dd}/${MM}/${yyyy} ${HH}:${mm}`, value: "dd/MM/yyyy HH:mm" },
                { label: `${dd}.${MM}.${yyyy}`, value: "dd.MM.yyyy" },
                { label: `${yyyy}/${M}/${d}`, value: "yyyy/M/d" },
                { label: `${M}/${d}/${yyyy}`, value: "M/d/yyyy" },
                { label: `${M}/${d}/${yy}`, value: "M/d/yy" },
                { label: `${d}/${M}/${yyyy}`, value: "d/M/yyyy" },
                { label: `${d}/${M}/${yy}`, value: "d/M/yy" },
                { label: `${M}.${d}.${yyyy}`, value: "M.d.yyyy" },
                { label: `${d}.${M}.${yyyy}`, value: "d.M.yyyy" },
                { label: `${yy}-${M}-${d}`, value: "yy-M-d" },
                { label: `${MM}-${dd}-${yy}`, value: "MM-dd-yy" },
                { label: `${MMMM} ${d},${yyyy}`, value: "MMMM d,yyyy" },
                { label: `${dddd} ${MMMM},${dd},${yyyy}`, value: "dddd,MMMM dd,yyyy" },
                { label: `${d} ${MMMM} ${yyyy}`, value: "d MMMM yyyy" },
                { label: `${d}-${MMM}-${yy}`, value: "d-MMM-yy" },
                { label: `${MMM}.${d},${yy}`, value: "MMM.d,yy" },
            ];
            console.log(this.timeDateStyleList);
        }
        activated() {
            this.$bus.$emit("setRightViewTitle", "pageSet");
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "页面设置",
    "content": {
      "pageBtn": {
        "bgColor": "背景色",
        "delBg": "删除背景",
        "waterMark": "水印"
      },
      "pageSize": {
        "title": "设置页面",
        "checkbox": "自动拓展页面大小",
        "presetRadio": "预设页面大小",
        "customRadio": "自定义大小",
        "unit": "单位",
        "size": "大小",
        "pageSizeList": [
          "Letter, 8.5 in x 11 in",
          "Follo, 8.5 in x 13 in",
          "Legal, 8.5 in x 14 in",
          "Executive, 7.25 in x 10.5 in",
          "Statement, 5.5 in x 8.5in",
          "#10 信封, 4.125 in x 9.5 in",
          "Monarch 信封, 3.875 in x 7.5 in",
          "Tabloid, 11 in x 17 in",
          "Letter(小), 8 1/2 in x 11 in",
          "C, 17 in x 22 in",
          "D, 22 in x 34 in",
          "E, 34 in x 44 in",
          "A3, 297mm x 420 mm",
          "A4, 210mm x 297 mm",
          "A5, 148mm x 210 mm",
          "B4, 250mm x 354 mm",
          "B4, 182mm x 257 mm",
          "DL 信封, 110 mm x 220 mm",
          "C5 信封, 162 mm x 229 mm",
          "Quarto, 215 mm x 275 mm",
          "C6 信封, 114 mm x 162 mm",
          "B5 信封, 176mm x 250 mm",
          "意大利信封, 110 mm x 230 mm",
          "A4 小纸张, 210 mm x 297 mm",
          "德国 Std Fanfold, 8.5 in x 13 in",
          "德国 Legal Fanfold, 8 in x 13 in",
          "PRC 16开, 146 mm x 215 mm",
          "PRC 32开, 97 mm x 151 mm",
          "日本明信片",
          "Double Japanese Postcard",
          "22 in x 36 in",
          "24 in x 48 in",
          "24 in x 60 in",
          "24 in x 72 in",
          "24 in x 84 in",
          "24 in x 96 in",
          "24 in x 108 in",
          "36 in x 42 in",
          "36 in x 60 in",
          "36 in x 72 in",
          "36 in x 84 in",
          "36 in x 96 in",
          "36 in x 108 in",
          "8.5 in x 10 in",
          "ARCH A",
          "ARCH B",
          "ARCH C",
          "ARCH D",
          "ARCH E",
          "ARCH E1",
          "ISO A0 [841 x 1189 mm]",
          "ISO A1 [594 x 841 mm]",
          "ISO A2 [420 x 594 mm]",
          "ISO B1 [707 x 1000 mm]",
          "B1(JIS) [728 x 1030 mm]",
          "B2(JIS) [515 x 728 mm]",
          "B3(JIS) [364 x 515 mm]",
          "B4(JIS) [257 x 364 mm]",
          "B5(JIS) [182 x 257 mm]",
          "2A [1189 x 1682 mm]",
          "4A [1682 x 2378 mm]",
          "PPT 16:9",
          "PPT 4:3"
        ],
        "pageUnitList": [
          "毫米",
          "厘米",
          "米",
          "千米",
          "英寸",
          "英尺和英寸",
          "英尺",
          "码",
          "英里",
          "点",
          "皮卡",
          "迪多",
          "西塞罗",
          "像素"
        ]
      },
      "pageDirect": {
        "title": "页面方向",
        "horizontal": "横向页面",
        "vertical": "纵向页面"
      },
      "UnitForPage": {
        "title": "单位"
      },
      "pageNum": {
        "title": "设置页码",
        "pageNumStyle": "页码样式",
        "pageNumPosition": "页码位置",
        "pageNumStyleList": [
          "无",
          "1",
          "1/1",
          "页 1",
          "~1~"
        ],
        "pageNumPositionList": [
          "左",
          "居中",
          "右"
        ]
      },
       "timeDate": {
        "title": "设置日期",
        "timeDateType":"日期类型",
        "timeDateStyle": "日期样式",
        "timeDatePosition": "日期位置",
        "timeDateTypeList": [
          "无",
          "创建日期",
          "当前日期",
          "上次编辑日期"
        ],
        "timeDatePositionList": [
          "左上",
          "顶部居中",
          "右上",
          "左下",
          "底部居中",
          "右下"
        ]
      },
      "autoFit": {
        "title": "适应页面",
        "autoFitText": "根据内容裁剪页面"
      },
      "grid": {
        "title": "设置网格",
        "fitRuler": "根据标尺自动计算",
        "value1": "网格水平间距",
        "value2": "网格水平细分",
        "value3": "网格垂直间距",
        "value4": "网格垂直细分"
      }
    }
  },
  "en": {
    "title": "Page",
    "content": {
      "pageBtn": {
        "bgColor": "Background",
        "delBg": "Remove Background",
        "waterMark": "Watermark"
      },
      "pageSize": {
        "title": "Page Setup",
        "checkbox": "Auto Size",
        "presetRadio": "Predefined",
        "customRadio": "Custom",
        "unit": "Unit",
        "size": "Size",
        "pageSizeList": [
          "Letter, 8.5 in x 11 in",
          "Follo, 8.5 in x 13 in",
          "Legal, 8.5 in x 14 in",
          "Executive, 7.25 in x 10.5 in",
          "Statement, 5.5 in x 8.5in",
          "#10 Envelope, 4.125 in x 9.5 in",
          "Monarch Envelope, 3.875 in x 7.5 in",
          "Tabloid, 11 in x 17 in",
          "Letter Small, 8 1/2 in x 11 in",
          "C Sheet, 17 in x 22 in",
          "D Sheet, 22 in x 34 in",
          "E Sheet, 34 in x 44 in",
          "A3 sheet, 297mm x 420 mm",
          "A4 sheet, 210mm x 297 mm",
          "A5 sheet, 148mm x 210 mm",
          "B4 sheet, 250mm x 354 mm",
          "B4 sheet, 182mm x 257 mm",
          "DL Envelope, 110 mm x 220 mm",
          "C5 Envelope, 162 mm x 229 mm",
          "Quarto, 215 mm x 275 mm",
          "C6 Envelope, 114 mm x 162 mm",
          "B5 Envelope, 176mm x 250 mm",
          "Italy Envelope, 110 mm x 230 mm",
          "A4 small sheet, 210 mm x 297 mm",
          "German Std Fanfold, 8.5 in x 13 in",
          "German Legal Fanfold, 8 in x 13 in",
          "PRC 16K, 146 mm x 215 mm",
          "PRC 32K, 97 mm x 151 mm",
          "Japanese Postcard",
          "Double Japanese Postcard",
          "22 in x 36 in",
          "24 in x 48 in",
          "24 in x 60 in",
          "24 in x 72 in",
          "24 in x 84 in",
          "24 in x 96 in",
          "24 in x 108 in",
          "36 in x 42 in",
          "36 in x 60 in",
          "36 in x 72 in",
          "36 in x 84 in",
          "36 in x 96 in",
          "36 in x 108 in",
          "8.5 in x 10 in",
          "ARCH A",
          "ARCH B",
          "ARCH C",
          "ARCH D",
          "ARCH E",
          "ARCH E1",
          "ISO A0 [841 x 1189 mm]",
          "ISO A1 [594 x 841 mm]",
          "ISO A2 [420 x 594 mm]",
          "ISO B1 [707 x 1000 mm]",
          "B1(JIS) [728 x 1030 mm]",
          "B2(JIS) [515 x 728 mm]",
          "B3(JIS) [364 x 515 mm]",
          "B4(JIS) [257 x 364 mm]",
          "B5(JIS) [182 x 257 mm]",
          "2A [1189 x 1682 mm]",
          "4A [1682 x 2378 mm]",
          "PowerPoint 16:9",
          "PowerPoint 4:3"
        ],
        "pageUnitList": [
          "Millimeters",
          "Centimeters",
          "Meters",
          "Kilometers",
          "Inches",
          "Feet and Inches",
          "Feet",
          "Yard",
          "Mile",
          "Points",
          "Pica",
          "Didot",
          "Cicero",
          "Pixel"
        ]
      },
      "pageDirect": {
        "title": "Orientation",
        "horizontal": "Landscape",
        "vertical": "Portrait"
      },
      "UnitForPage": {
        "title": "Unit"
      },
      "pageNum": {
        "title": "Page Number",
        "pageNumStyle": "Page Number Style",
        "pageNumPosition": "Page Number Position",
        "pageNumStyleList": [
          "None",
          "1",
          "1/1",
          "Page 1",
          "~1~"
        ],
        "pageNumPositionList": [
          "Left",
          "Center",
          "Right"
        ]
      },
       "timeDate": {
        "title": "Date",
        "timeDateType":"Types",
        "timeDateStyle": "Styles",
        "timeDatePosition": "Position",
        "timeDateTypeList": [
          "None",
          "Create date",
          "Current date",
          "Recent edited date"
        ],
        "timeDatePositionList": [
          "Upper left",
          "Top center",
          "Upper right",
          "Lower left",
          "Botton center",
          "Lower right"
        ]
      },
      "autoFit": {
        "title": "Fit to",
        "autoFitText": "Fit to Drawing"
      },
      "grid": {
        "title": "Grid",
        "fitRuler": "Fit to Ruler",
        "value1": "Horizontal Spacing",
        "value2": "Horizontal Subdivisions",
        "value3": "Vertical Spacing",
        "value4": "Vertical Subdivisions"
      }
    }
  },
  "fr": {
    "title": "Mise en page",
    "content": {
      "pageBtn": {
        "bgColor": "Couleur de fond",
        "delBg": "Supprimer l'arrière-plan",
        "waterMark": "Filigrane"
      },
      "pageSize": {
        "title": "Paramètre la page ",
        "checkbox": "Étendre automatiquement la taille de la page",
        "presetRadio": "Taille de page prédéfinie",
        "customRadio": "Taille personnalisée",
        "unit": "Unité",
        "size": "Taille ",
        "pageSizeList": [
          "Lettre, 8,5 po x 11 po",
          "Follo, 8,5 po x 13 po",
          "Légal, 8,5 po x 14 po",
          "Exécutif, 7,25 po x 10,5 po",
          "Énoncé, 5,5 po x 8,5 po",
          "Enveloppe n ° 10, 4,125 po x 9,5 po",
          "Enveloppe Monarch, 3,875 po x 7,5 po",
          "Tabloïde, 11 po x 17 po",
          "Lettre petite, 8 1/2 po x 11 po",
          "Feuille C, 17 po x 22 po",
          "Feuille D, 22 po x 34 po",
          "Feuille E, 34 po x 44 po",
          "Feuille A3, 297 mm x 420 mm",
          "Feuille A4, 210 mm x 297 mm",
          "Feuille A5, 148mm x 210 mm",
          "Feuille B4, 250mm x 354 mm",
          "Feuille B4, 182mm x 257 mm",
          "Enveloppe DL, 110 mm x 220 mm",
          "Enveloppe C5, 162 mm x 229 mm",
          "Quarto, 215 mm x 275 mm",
          "Enveloppe C6, 114 mm x 162 mm",
          "Enveloppe B5, 176mm x 250 mm",
          "Enveloppe Italie, 110 mm x 230 mm",
          "Petite feuille A4, 210 mm x 297 mm",
          "Pliage standard allemand, 8,5 po x 13 po",
          "Porte-documents juridique allemand, 8 po x 13 po",
          "PRC 16K, 146 mm x 215 mm",
          "PRC 32K, 97 mm x 151 mm",
          "Carte postale japonaise",
          "Double Japanese Postcard",
          "22 po x 36 po ",
          "24 po x 48 po ",
          "24 po x 60 po ",
          "24 po x 72 po",
          "24 po x 84 po",
          "24 po x 96 po",
          "24 po x 108 po",
          "36 po x 42 po",
          "36 po x 60 po",
          "36 po x 72 po",
          "36 po x 84 po",
          "36 po x 96 po",
          "36 po x 108 po",
          "8.5 po x 10 po",
          "ARCH A",
          "ARCH B",
          "ARCH C",
          "ARCH D",
          "ARCH E",
          "ARCH E1",
          "ISO A0 [841 x 1189 mm]",
          "ISO A1 [594 x 841 mm]",
          "ISO A2 [420 x 594 mm]",
          "ISO B1 [707 x 1000 mm]",
          "B1(JIS) [728 x 1030 mm]",
          "B2(JIS) [515 x 728 mm]",
          "B3(JIS) [364 x 515 mm]",
          "B4(JIS) [257 x 364 mm]",
          "B5(JIS) [182 x 257 mm]",
          "2A [1189 x 1682 mm]",
          "4A [1682 x 2378 mm]",
          "PowerPoint 16:9",
          "PowerPoint 4:3"
        ],
        "pageUnitList": [
          "mm",
          "cm",
          "m",
          "km",
          "Pouce",
          "Pieds et pouces",
          "Pieds ",
          "Cour",
          "Miles",
          "Points",
          "Pica",
          "Didot",
          "Cicero",
          "Pixel"
        ]
      },
      "pageDirect": {
        "title": "Orientation de la page",
        "horizontal": "Page paysage",
        "vertical": "Page portrait"
      },
      "UnitForPage": {
        "title": "Unité"
      },
      "pageNum": {
        "title": "Définir le numéro de page",
        "pageNumStyle": "Style de numéro de page",
        "pageNumPosition": "Position du numéro de page",
        "pageNumStyleList": [
          "Aucun",
          "1",
          "1/1",
          "Page 1",
          "~1~"
        ],
        "pageNumPositionList": [
          "Gauche",
          "Centre",
          "Droit"
        ]
      },
       "timeDate": {
        "title": "Date",
        "timeDateType":"Types",
        "timeDateStyle": "Styles",
        "timeDatePosition": "Position",
        "timeDateTypeList": [
          "Aucun",
          "Date de création",
          "Date actuelle",
          "Date de la dernière modification"
        ],
        "timeDatePositionList": [
          "En haut à gauche",
          "Centre supérieur",
          "En haut à droite",
          "En bas à gauche",
          "En bas au centre",
          "En bas à droite"
        ]
      },
      "autoFit": {
        "title": "Ajuster à la page",
        "autoFitText": "Recadrer la page en fonction du contenu"
      },
      "grid": {
        "title": "Configuration de la grille",
        "fitRuler": "Calcul automatique basé sur la règle",
        "value1": "Espacement horizontal de la grille",
        "value2": "Subdivision horizontale de la grille",
        "value3": "Espacement vertical de la grille",
        "value4": "Subdivision verticale de la grille"
      }
    }
  },
  "de": {
    "title": "Seite",
    "content": {
      "pageBtn": {
        "bgColor": "Hintergrundfarbe",
        "delBg": "Hintergrund entfernen",
        "waterMark": "Wasserzeichen"
      },
      "pageSize": {
        "title": "Seite erstellen",
        "checkbox": "Automatische Größenanpassung",
        "presetRadio": "Vorgegeben",
        "customRadio": "Benutzerdefiniert",
        "unit": "Einheit",
        "size": "Größe",
        "pageSizeList": [
          "Letter, 8.5 in x 11 in",
          "Follo, 8.5 in x 13 in",
          "Legal, 8.5 in x 14 in",
          "Executive, 7.25 in x 10.5 in",
          "Statement, 5.5 in x 8.5in",
          "#10 Envelope, 4.125 in x 9.5 in",
          "Monarch Envelope, 3.875 in x 7.5 in",
          "Tabloid, 11 in x 17 in",
          "Letter Small, 8 1/2 in x 11 in",
          "C Sheet, 17 in x 22 in",
          "D Sheet, 22 in x 34 in",
          "E Sheet, 34 in x 44 in",
          "A3 sheet, 297mm x 420 mm",
          "A4 sheet, 210mm x 297 mm",
          "A5 sheet, 148mm x 210 mm",
          "B4 sheet, 250mm x 354 mm",
          "B4 sheet, 182mm x 257 mm",
          "DL Envelope, 110 mm x 220 mm",
          "C5 Envelope, 162 mm x 229 mm",
          "Quarto, 215 mm x 275 mm",
          "C6 Envelope, 114 mm x 162 mm",
          "B5 Envelope, 176mm x 250 mm",
          "Italy Envelope, 110 mm x 230 mm",
          "A4 small sheet, 210 mm x 297 mm",
          "German Std Fanfold, 8.5 in x 13 in",
          "German Legal Fanfold, 8 in x 13 in",
          "PRC 16K, 146 mm x 215 mm",
          "PRC 32K, 97 mm x 151 mm",
          "Japanese Postcard",
          "Double Japanese Postcard",
          "22 in x 36 in",
          "24 in x 48 in",
          "24 in x 60 in",
          "24 in x 72 in",
          "24 in x 84 in",
          "24 in x 96 in",
          "24 in x 108 in",
          "36 in x 42 in",
          "36 in x 60 in",
          "36 in x 72 in",
          "36 in x 84 in",
          "36 in x 96 in",
          "36 in x 108 in",
          "8.5 in x 10 in",
          "ARCH A",
          "ARCH B",
          "ARCH C",
          "ARCH D",
          "ARCH E",
          "ARCH E1",
          "ISO A0 [841 x 1189 mm]",
          "ISO A1 [594 x 841 mm]",
          "ISO A2 [420 x 594 mm]",
          "ISO B1 [707 x 1000 mm]",
          "B1(JIS) [728 x 1030 mm]",
          "B2(JIS) [515 x 728 mm]",
          "B3(JIS) [364 x 515 mm]",
          "B4(JIS) [257 x 364 mm]",
          "B5(JIS) [182 x 257 mm]",
          "2A [1189 x 1682 mm]",
          "4A [1682 x 2378 mm]",
          "PowerPoint 16:9",
          "PowerPoint 4:3"
        ],
        "pageUnitList": [
          "Millimeter",
          "Zentimeter",
          "Meter",
          "Kilometer",
          "Inch",
          "Füße und Zoll",
          "Füße",
          "Yard",
          "Meile ",
          "Punkt",
          "Pika",
          "Dido",
          "Cicero",
          "Pixel"
        ]
      },
      "pageDirect": {
        "title": "Ausrichtung",
        "horizontal": "Querformat",
        "vertical": "Hochformat"
      },
      "UnitForPage": {
        "title": "Einheit"
      },
      "pageNum": {
        "title": "Seitenzahl",
        "pageNumStyle": "Seitenzahlstil",
        "pageNumPosition": "Position Seitenzahl",
        "pageNumStyleList": [
          "Nichts",
          "1",
          "1/1",
          "Seite 1",
          "~1~"
        ],
        "pageNumPositionList": [
          "Links",
          "Mittel",
          "Rechts"
        ]
      },
       "timeDate": {
        "title": "Datum",
        "timeDateType":"Typen",
        "timeDateStyle": "Stile",
        "timeDatePosition": "Position",
        "timeDateTypeList": [
          "Nichts",
          "Datum erstellen",
          "Datum aktualisieren",
          "Letzte Bearbeitung Datum"
        ],
        "timeDatePositionList": [
          "Oben links",
          "Oben mittig",
          "Oben rechts",
          "Unten links",
          "Unten mittig",
          "Unten rechts"
        ]
      },
      "autoFit": {
        "title": "Automatisch anpassen",
        "autoFitText": "Größe an Zeichnung anpassen"
      },
      "grid": {
        "title": "Gitter",
        "fitRuler": "An Lineal anpassen",
        "value1": "Horizontaler Abstand",
        "value2": "Horizontale Unterteilungen",
        "value3": "Vertikaler Abstand",
        "value4": "Vertikale Unterteilungen"
      }
    }
  },
  "jp": {
    "title": "ページ設定",
    "content": {
      "pageBtn": {
        "bgColor": "背景色",
        "delBg": "背景を削除",
        "waterMark": "透かし"
      },
      "pageSize": {
        "title": "ページ設定",
        "checkbox": "自動合わせる",
        "presetRadio": "内蔵サイズ",
        "customRadio": "カスタム",
        "unit": "単位",
        "size": "サイズ",
        "pageSizeList": [
          "便箋, 8.5 in x 11 in",
          "Follo, 8.5 in x 13 in",
          "法律専用紙 8.5 in x 14 in",
          "Executive, 7.25 in x 10.5 in",
          "Statement, 5.5 in x 8.5in",
          "#10 Envelope, 4.125 in x 9.5 in",
          "モナーク封筒 3.875 in x 7.5 in",
          "Tabloid, 11 in x 17 in",
          "小さな手紙 8 1/2 in x 11 in",
          "C シート 17 in x 22 in",
          "D シート 22 in x 34 in",
          "E シート 34 in x 44 in",
          "A3 シート 297mm x 420 mm",
          "A4 シート 210mm x 297 mm",
          "A5 シート 148mm x 210 mm",
          "B4 シート 250mm x 354 mm",
          "B4 シート 182mm x 257 mm",
          "DL 封筒 110 mm x 220 mm",
          "C5 封筒 162 mm x 229 mm",
          "四つ折り 215 mm x 275 mm",
          "C6 封筒 114 mm x 162 mm",
          "B5 封筒 176mm x 250 mm",
          "イタリア封筒 110 mm x 230 mm",
          "小さなA4シート 210 mm x 297 mm",
          "ドイツの標準ファンフォールド 8.5 in x 13 in",
          "ドイツの法律ファンフォールド 8 in x 13 in",
          "PRC 16K 146 mm x 215 mm",
          "PRC 32K 97 mm x 151 mm",
          "日本はがき",
          "ダブルはがき",
          "22 in x 36 in",
          "24 in x 48 in",
          "24 in x 60 in",
          "24 in x 72 in",
          "24 in x 84 in",
          "24 in x 96 in",
          "24 in x 108 in",
          "36 in x 42 in",
          "36 in x 60 in",
          "36 in x 72 in",
          "36 in x 84 in",
          "36 in x 96 in",
          "36 in x 108 in",
          "8.5 in x 10 in",
          "ARCH A",
          "ARCH B",
          "ARCH C",
          "ARCH D",
          "ARCH E",
          "ARCH E1",
          "ISO A0 [841 x 1189 mm]",
          "ISO A1 [594 x 841 mm]",
          "ISO A2 [420 x 594 mm]",
          "ISO B1 [707 x 1000 mm]",
          "B1(JIS) [728 x 1030 mm]",
          "B2(JIS) [515 x 728 mm]",
          "B3(JIS) [364 x 515 mm]",
          "B4(JIS) [257 x 364 mm]",
          "B5(JIS) [182 x 257 mm]",
          "2A [1189 x 1682 mm]",
          "4A [1682 x 2378 mm]",
          "PowerPoint 16:9",
          "PowerPoint 4:3"
        ],
        "pageUnitList": [
          "ミリメートル",
          "センチ",
          "メートル",
          "キロ",
          "インチ",
          "フィートとインチ",
          "フィート",
          "ヤード",
          "マイル",
          "点",
          "パイカ",
          "ディド",
          "シセロ",
          "画素"
        ]
      },
      "pageDirect": {
        "title": "ページの向き",
        "horizontal": "横向き",
        "vertical": "縦向き"
      },
      "UnitForPage": {
        "title": "単位"
      },
      "pageNum": {
        "title": "ページ番号",
        "pageNumStyle": "番号書式",
        "pageNumPosition": "位置",
        "pageNumStyleList": [
          "なし",
          "1",
          "1/1",
          "ページ 1",
          "~1~"
        ],
        "pageNumPositionList": [
          "ページ下部の左側",
          "ページ下部の中央",
          "ページ下部の右側"
        ]
      },
        "timeDate": {
        "title": "日付",
        "timeDateType":"種類",
        "timeDateStyle": "スタイル",
        "timeDatePosition": "位置",
        "timeDateTypeList": [
          "なし",
          "作成日時",
          "現在の日時",
          "最終更新日時"
        ],
        "timeDatePositionList": [
          "左上",
          "上中央",
          "右上",
          "左下",
          "下中央",
          "右下 "
        ]
      },
      "autoFit": {
        "title": "ページに合わせる",
        "autoFitText": "図面ページに合わせる"
      },
      "grid": {
        "title": "グリッドを設定",
        "fitRuler": "ルーラーに合わせる",
        "value1": "グリッドの水平間隔",
        "value2": "グリッドの水平細分割",
        "value3": "グリッドの垂直間隔",
        "value4": "グリッドの垂直細分割"
      }
    }
  },
  "es": {
    "title": "Página",
    "content": {
      "pageBtn": {
        "bgColor": "Fondo",
        "delBg": "Eliminar el fondo",
        "waterMark": "Marca de agua"
      },
      "pageSize": {
        "title": "Configuración de la página",
        "checkbox": "Tamaño automático",
        "presetRadio": "Predefinido",
        "customRadio": "Personalizado",
        "unit": "Unidad",
        "size": "Tamaño",
        "pageSizeList": [
          "Carta, 8.5 en x 11 en",
          "Follo, 8.5 in x 13 in",
          "Legal, 8.5 en x 14 en",
          "Ejecutivo, 7,25 x 10,5",
          "Declaración, 5.5 en x 8.5in",
          "Sobre número 10, 4.125 x 9.5",
          "Sobre Monarca, 3.875 x 7.5",
          "Tabloide, 11 en x 17 en",
          "Letra pequeña, 8 1/2 pulg. x 11 pulg",
          "Hoja C, 17 en x 22 en",
          "Hoja D, 22 en x 34 en",
          "Hoja E, 34 en x 44 en",
          "Hoja A3, 297mm x 420 mm",
          "Hoja A4, 210mm x 297 mm",
          "Hoja A5, 148mm x 210 mm",
          "Hoja B4, 250 mm x 354 mm",
          "Hoja B4, 182 mm x 257 mm",
          "Sobre DL, 110 mm x 220 mm",
          "Sobre C5, 162 mm x 229 mm",
          "Cuarto, 215 mm x 275 mm",
          "Sobre C6, 114 mm x 162 mm",
          "Sobre de Italia, 110 mm x 230 mm",
          "Sobre Italia, 110 mm x 230 mm",
          "Hoja pequeña A4, 210 mm x 297 mm",
          "Pliegue de fanáticos alemán, 8.5 x 13 pulgadas",
          "Plegado legal alemán, 8 x 13 pulgadas",
          "PRC 16K, 146 mm x 215 mm",
          "PRC 32K, 97 mm x 151 mm",
          "Postal japonesa",
          "Postal japonesa doble",
          "22 en x 36 en",
          "24 en x 48 en",
          "24 en x 60 en",
          "24 en x 72 en ",
          "24 en x 84 en ",
          "24 en x 96 en ",
          "24 en x 108 en ",
          "36 en x 42 en ",
          "36 en x 60 en ",
          "36 en x 72 en ",
          "36 en x 84 en ",
          "36 en x 96 en ",
          "36 en x 108 en ",
          "8.5 en x 10 en ",
          "ARCH A",
          "ARCH B",
          "ARCH C",
          "ARCH D",
          "ARCH E",
          "ARCH E1",
          "ISO A0 [841 x 1189 mm]",
          "ISO A1 [594 x 841 mm]",
          "ISO A2 [420 x 594 mm]",
          "ISO B1 [707 x 1000 mm]",
          "B1(JIS) [728 x 1030 mm]",
          "B2(JIS) [515 x 728 mm]",
          "B3(JIS) [364 x 515 mm]",
          "B4(JIS) [257 x 364 mm]",
          "B5(JIS) [182 x 257 mm]",
          "2A [1189 x 1682 mm]",
          "4A [1682 x 2378 mm]",
          "PowerPoint 16:9",
          "PowerPoint 4:3"
        ],
        "pageUnitList": [
          "Milímetros",
          "Centímetros",
          "Metros",
          "Kilómetros",
          "Pulgadas",
          "Pies y pulgadas",
          "Pies",
          "Yard",
          "Milla",
          "Puntos",
          "Pica",
          "Didot",
          "Cicerón",
          "Pixel"
        ]
      },
      "pageDirect": {
        "title": "Orientación",
        "horizontal": "paisaje",
        "vertical": "Retrato"
      },
      "UnitForPage": {
        "title": "Número de página"
      },
      "pageNum": {
        "title": "Configurar Número de la página",
        "pageNumStyle": "Estilo Número de Página",
        "pageNumPosition": "Posición del número de página",
        "pageNumStyleList": [
          "Ninguno",
          "1          ",
          "1/1",
          "Página 1",
          "~1~"
        ],
        "pageNumPositionList": [
          "Izquierda",
          "Centro",
          "Derecho"
        ]
      },
       "timeDate": {
        "title": "Fecha",
        "timeDateType":"Ninguno",
        "timeDateStyle": "Estilos",
        "timeDatePosition": "Posición",
        "timeDateTypeList": [
          "Ninguno",
          "Crear fecha",
          "Fecha Actual",
          "Fecha editadas recientemente"
        ],
        "timeDatePositionList": [
          "Superior izquierdo",
          "Centro Superior",
          "Superior derecho",
          "Parte inferior izquierda",
          "Centro inferior",
          "Inferior derecha "
        ]
      },
      "autoFit": {
        "title": "Ajustar págin",
        "autoFitText": "Ajustar al dibujo"
      },
      "grid": {
        "title": "Rejilla",
        "fitRuler": "Apto para gobernar",
        "value1": "Espacio horizontal",
        "value2": "Subdivisiones horizontales",
        "value3": "Espacio vertical",
        "value4": "Subdivisiones verticales"
      }
    }
  },
  "pt": {
    "title": "Página",
    "content": {
      "pageBtn": {
        "bgColor": "Fundo",
        "delBg": "Remover Fundo",
        "waterMark": "Marca de Água"
      },
      "pageSize": {
        "title": "Ajuste da Página",
        "checkbox": "Tamanho Automático",
        "presetRadio": "Predefinido",
        "customRadio": "Personalizar",
        "unit": "Unidade",
        "size": "Tamanho",
        "pageSizeList": [
          "Carta, 8.5 polegadas x 11 polegadas",
          "Fólio, 8.5 polegadas x 13 polegadas",
          "Legal, 8.5 polegadas x 14 polegadas",
          "Executivo, 7.25 polegadas x 10.5 polegadas",
          "Declaração, 5.5 polegadas x 8.5 polegadas",
          "#10 Envelope, 4.125 polegadas x 9.5 polegadas",
          "Envelope Monarca, 3.875 polegadas x 7.5 polegadas",
          "Tablóide, 11 polegadas x 17 polegadas",
          "Carta Pequena, 8 1/2 polegadas x 11 polegadas",
          "Folha C, 17 polegadas x 22 polegadas",
          "Folha D, 22 polegadas x 34 polegadas",
          "Folha E, 34 polegadas x 44 polegadas",
          "Folha A3, 297mm x 420 mm",
          "Folha A4, 210mm x 297 mm",
          "Folha A5, 148mm x 210 mm",
          "Folha B4, 250mm x 354 mm",
          "Folha B4, 182mm x 257 mm",
          "Envelope DL, 110 mm x 220 mm",
          "Envelope C5, 162 mm x 229 mm",
          "Quarto, 215 mm x 275 mm",
          "Envelope C6, 114 mm x 162 mm",
          "Envelope B5, 176mm x 250 mm",
          "Envelope Itália, 110 mm x 230 mm",
          "A4 folha pequena, 210 mm x 297 mm",
          "Contínuo Padrão Alemão, 8.5 polegadas x 13 polegadas",
          "Contínuo Legal Alemão, 8 polegadas x 13 polegadas",
          "PRC 16K, 146 mm x 215 mm",
          "PRC 32K, 97 mm x 151 mm",
          "Postal Japonês",
          "Postal Japonês Duplo",
          "22 polegadas x 36 polegadas",
          "24 polegadas x 48 polegadas",
          "24 polegadas x 60 polegadas",
          "24 polegadas x 72 polegadas",
          "24 polegadas x 84 polegadas",
          "24 polegadas x 96 polegadas",
          "24 polegadas x 108 polegadas",
          "36 polegadas x 42 polegadas",
          "36 polegadas x 60 polegadas",
          "36 polegadas x 72 polegadas",
          "36 polegadas x 84 polegadas",
          "36 polegadas x 96 polegadas",
          "36 polegadas x 108 polegadas",
          "8.5 polegadas x 10 polegadas",
          "ARCO A",
          "ARCO B",
          "ARCO C",
          "ARCO D",
          "ARCO E",
          "ARCO E1",
          "ISO A0 [841 x 1189 mm]",
          "ISO A1 [594 x 841 mm]",
          "ISO A2 [420 x 594 mm]",
          "ISO B1 [707 x 1000 mm]",
          "B1(JIS) [728 x 1030 mm]",
          "B2(JIS) [515 x 728 mm]",
          "B3(JIS) [364 x 515 mm]",
          "B4(JIS) [257 x 364 mm]",
          "B5(JIS) [182 x 257 mm]",
          "2A [1189 x 1682 mm]",
          "4A [1682 x 2378 mm]",
          "PowerPoint 16:9",
          "PowerPoint 4:3"
        ],
        "pageUnitList": [
          "Milímetros",
          "Centímetros",
          "Metros",
          "Quilómetros",
          "Polegadas",
          "Pés e Polegadas",
          "Pés",
          "Jarda",
          "Milha",
          "Pontos",
          "Paica",
          "Didot",
          "Cícero",
          "Pixel"
        ]
      },
      "pageDirect": {
        "title": "Orientação",
        "horizontal": "Paisagem",
        "vertical": "Retrato"
      },
      "UnitForPage": {
        "title": "Unidade"
      },
      "pageNum": {
        "title": "Número de Página",
        "pageNumStyle": "Estilo de Número de Página",
        "pageNumPosition": "Posição do Número de Página",
        "pageNumStyleList": [
          "Nenhum",
          "1",
          "1/1",
          "Página 1",
          "~1~"
        ],
        "pageNumPositionList": [
          "Esquerda",
          "Centro",
          "Direita"
        ]
      },
        "timeDate": {
        "title": "Data",
        "timeDateType":"Tipos",
        "timeDateStyle": "Estilo",
        "timeDatePosition": "Posição",
        "timeDateTypeList": [
          "Nenhum",
          "Data de criação",
          "Data atual",
          "Data editada recentemente"
        ],
        "timeDatePositionList": [
          "Esquerdo superior",
          "Centro superior",
          "Direito superior",
          "Esquerda inferior",
          "Centro inferior",
          "Direito inferior "
        ]
      },
      "autoFit": {
        "title": "Ajustar",
        "autoFitText": "Ajustar ao Desenho"
      },
      "grid": {
        "title": "Grelha",
        "fitRuler": "Ajustar a Régua",
        "value1": "Espaçamento Horizontal",
        "value2": "Subdivisões Horizontais",
        "value3": "Espaçamento Vertical",
        "value4": "Subdivisões Verticais"
      }
    }
  },
  "it": {
    "title": "Pagina",
    "content": {
      "pageBtn": {
        "bgColor": "Sfondo",
        "delBg": "Rimuovi Sfondo",
        "waterMark": "Filigrana"
      },
      "pageSize": {
        "title": "Impostazione Pagine",
        "checkbox": "Dimensione Automatica",
        "presetRadio": "Predefinita",
        "customRadio": "Personalizzata",
        "unit": "Unità",
        "size": "Dimensione",
        "pageSizeList": [
          "Lettera, 8.5 x 11 pollici",
          "Foglio, 8.5 x 13 pollici",
          "Legale, 8.5 x 14 pollici",
          "Executive, 7.25 x 10.5 pollici",
          "Rendiconto, 5.5 x 8.5 pollici",
          "Busta #10, 4.125 x 9.5 pollici",
          "Busta Monarch, 3.875 x 7.5 pollici",
          "Tabloid, 11 x 17 pollici",
          "Lettera Piccola, 8 1/2 x 11 pollici",
          "Foglio C, 17 x 22 pollici",
          "Foglio D, 22 x 34 pollici",
          "Foglio E, 34 x 44 pollici",
          "Foglio A3, 297mm x 420 mm",
          "Foglio A4, 210mm x 297 mm",
          "Foglio A5, 148mm x 210 mm",
          "Foglio B4, 250mm x 354 mm",
          "Foglio B4, 182mm x 257 mm",
          "Busta DL, 110 mm x 220 mm",
          "Busta C5, 162 mm x 229 mm",
          "Quarto, 215 mm x 275 mm",
          "Busta C6, 114 mm x 162 mm",
          "Busta B5, 176mm x 250 mm",
          "Busta Italiana, 110 mm x 230 mm",
          "Foglio Piccolo A4, 210 mm x 297 mm",
          "German Std Fanfold, 8.5 x 13 pollici",
          "German Legal Fanfold, 8 x 13 pollici",
          "PRC 16K, 146 mm x 215 mm",
          "PRC 32K, 97 mm x 151 mm",
          "Cartolina Giapponese",
          "Cartolina Giapponese Doppia",
          "22 x 36 pollici",
          "24 x 48 pollici",
          "24 x 60 pollici",
          "24 x 72 pollici",
          "24 x 84 pollici",
          "24 x 96 pollici",
          "24 x 108 pollici",
          "36 x 42 pollici",
          "36 x 60 pollici",
          "36 x 72 pollici",
          "36 x 84 pollici",
          "36 x 96 pollici",
          "36 x 108 pollici",
          "8.5 x 10 pollici",
          "ARCH A",
          "ARCH B",
          "ARCH C",
          "ARCH D",
          "ARCH E",
          "ARCH E1",
          "ISO A0 [841 x 1189 mm]",
          "ISO A1 [594 x 841 mm]",
          "ISO A2 [420 x 594 mm]",
          "ISO B1 [707 x 1000 mm]",
          "B1(JIS) [728 x 1030 mm]",
          "B2(JIS) [515 x 728 mm]",
          "B3(JIS) [364 x 515 mm]",
          "B4(JIS) [257 x 364 mm]",
          "B5(JIS) [182 x 257 mm]",
          "2A [1189 x 1682 mm]",
          "4A [1682 x 2378 mm]",
          "PowerPoint 16:9",
          "PowerPoint 4:3"
        ],
        "pageUnitList": [
          "Millimetri",
          "Centimetri",
          "Metri",
          "Chilometri",
          "Pollici",
          "Piedi e Pollici",
          "Piedi",
          "Yard",
          "Miglia",
          "Punti",
          "Pica",
          "Didot",
          "Ciceri",
          "Pixel"
        ]
      },
      "pageDirect": {
        "title": "Orientamento",
        "horizontal": "Orizzontale",
        "vertical": "Verticale"
      },
      "UnitForPage": {
        "title": "Unità"
      },
      "pageNum": {
        "title": "Numero Pagina",
        "pageNumStyle": "Stile Numero Pagina",
        "pageNumPosition": "Posizione Numero Pagina",
        "pageNumStyleList": [
          "Nessuno",
          "1",
          "1/1",
          "Pagina 1",
          "~1~"
        ],
        "pageNumPositionList": [
          "Sinistra",
          "Centro",
          "Destra"
        ]
      },
      "timeDate": {
        "title": "Data",
        "timeDateType":"Tipi",
        "timeDateStyle": "Stili",
        "timeDatePosition": "Posizione",
        "timeDateTypeList": [
          "Nessuno",
          "Crea data",
          "Data corrente",
          "Data modificata di recente"
        ],
        "timeDatePositionList": [
          "Superiore sinistro",
          "In alto al centro",
          "Superiore destra",
          "In basso a sinistra",
          "In basso al centro",
          "In basso a destra "
        ]
      },
      "autoFit": {
        "title": "Adatta a",
        "autoFitText": "Adatta al Disegno"
      },
      "grid": {
        "title": "Griglia",
        "fitRuler": "Adatta a Righello",
        "value1": "Spaziatura Orizzontale",
        "value2": "Suddivisioni Orizzontali",
        "value3": "Spaziatura Verticale",
        "value4": "Suddivisioni Verticali"
      }
    }
  },
  "tw": {
    "title": "頁面設置",
    "content": {
      "pageBtn": {
        "bgColor": "背景色",
        "delBg": "刪除背景",
        "waterMark": "水印"
      },
      "pageSize": {
        "title": "設置頁面",
        "checkbox": "自動拓展頁面大小",
        "presetRadio": "預設頁面大小",
        "customRadio": "自定義大小",
        "unit": "單位",
        "size": "大小",
        "pageSizeList": [
          "Letter, 8.5 in x 11 in",
          "Follo, 8.5 in x 13 in",
          "Legal, 8.5 in x 14 in",
          "Executive, 7.25 in x 10.5 in",
          "Statement, 5.5 in x 8.5in",
          "#10 信封, 4.125 in x 9.5 in",
          "Monarch 信封, 3.875 in x 7.5 in",
          "Tabloid, 11 in x 17 in",
          "Letter(小), 8 1/2 in x 11 in",
          "C, 17 in x 22 in",
          "D, 22 in x 34 in",
          "E, 34 in x 44 in",
          "A3, 297mm x 420 mm",
          "A4, 210mm x 297 mm",
          "A5, 148mm x 210 mm",
          "B4, 250mm x 354 mm",
          "B4, 182mm x 257 mm",
          "DL 信封, 110 mm x 220 mm",
          "C5 信封, 162 mm x 229 mm",
          "Quarto, 215 mm x 275 mm",
          "C6 信封, 114 mm x 162 mm",
          "B5 信封, 176mm x 250 mm",
          "義大利信封, 110 mm x 230 mm",
          "A4 小紙張, 210 mm x 297 mm",
          "德國 Std Fanfold, 8.5 in x 13 in",
          "德國 Legal Fanfold, 8 in x 13 in",
          "PRC 16开, 146 mm x 215 mm",
          "PRC 32开, 97 mm x 151 mm",
          "日本明信片",
          "Double Japanese Postcard",
          "22 in x 36 in",
          "24 in x 48 in",
          "24 in x 60 in",
          "24 in x 72 in",
          "24 in x 84 in",
          "24 in x 96 in",
          "24 in x 108 in",
          "36 in x 42 in",
          "36 in x 60 in",
          "36 in x 72 in",
          "36 in x 84 in",
          "36 in x 96 in",
          "36 in x 108 in",
          "8.5 in x 10 in",
          "ARCH A",
          "ARCH B",
          "ARCH C",
          "ARCH D",
          "ARCH E",
          "ARCH E1",
          "ISO A0 [841 x 1189 mm]",
          "ISO A1 [594 x 841 mm]",
          "ISO A2 [420 x 594 mm]",
          "ISO B1 [707 x 1000 mm]",
          "B1(JIS) [728 x 1030 mm]",
          "B2(JIS) [515 x 728 mm]",
          "B3(JIS) [364 x 515 mm]",
          "B4(JIS) [257 x 364 mm]",
          "B5(JIS) [182 x 257 mm]",
          "2A [1189 x 1682 mm]",
          "4A [1682 x 2378 mm]",
          "PowerPoint 16:9",
          "PowerPoint 4:3"
        ],
        "pageUnitList": [
          "公釐",
          "公分",
          "公尺",
          "公里",
          "英吋",
          "英呎和英吋",
          "英呎",
          "碼",
          "英哩",
          "點",
          "皮卡",
          "迪多",
          "西塞羅",
          "像素"
        ]
      },
      "pageDirect": {
        "title": "頁面方向",
        "horizontal": "橫向頁面",
        "vertical": "縱向頁面"
      },
      "UnitForPage": {
        "title": "單位"
      },
      "pageNum": {
        "title": "設置頁碼",
        "pageNumStyle": "頁碼樣式",
        "pageNumPosition": "頁碼位置",
        "pageNumStyleList": [
          "無",
          "1",
          "1/1",
          "頁 1",
          "~1~"
        ],
        "pageNumPositionList": [
          "左",
          "居中",
          "右"
        ]
      },
       "timeDate": {
        "title": "日期",
        "timeDateType":"類型",
        "timeDateStyle": "樣式",
        "timeDatePosition": "位置",
        "timeDateTypeList": [
          "無",
          "建立日期",
          "當前日期",
          "最近編輯的日期"
        ],
        "timeDatePositionList": [
          "左上",
          "上中",
          "右上",
          "左下",
          "下中",
          "右下 "
        ]
      },
      "autoFit": {
        "title": "適合頁面",
        "autoFitText": "根據內容裁剪頁面"
      },
      "grid": {
        "title": "設置網格",
        "fitRuler": "根據標尺自動計算",
        "value1": "網格水平間距",
        "value2": "網格水平細分",
        "value3": "網格垂直間距",
        "value4": "網格垂直細分"
      }
    }
  }
}
</i18n>
